import apiClient from '@/services/api/apiClient';
import { QueryParams } from '@/model';
import { buildApiUrl } from '../utils';
import {
  GetNewsCalendarNewsResponse,
  PostNewsCalendarNewsResponse,
  PutNewsCalendarNewsResponse,
  GetNewsCalendarNewsByIdResponse,
} from '../response/news';
import { PostNewsCalendarNewsRequest, PutNewsCalendarNewsRequest } from '../request/news';

export class NewsService {
  static getNews(params?: QueryParams) {
    return apiClient.get<GetNewsCalendarNewsResponse>(buildApiUrl('/api/v1/news-calendar/news'), params);
  }

  static postNews(data: PostNewsCalendarNewsRequest) {
    return apiClient.createWithFile<PostNewsCalendarNewsResponse>(buildApiUrl('/api/v1/news-calendar/news'), data);
  }

  static getNewsById(id: string) {
    const url = buildApiUrl('/api/v1/news-calendar/news/:id', { id });
    return apiClient.get<GetNewsCalendarNewsByIdResponse>(url, undefined);
  }

  static putNews(id: string, data: PutNewsCalendarNewsRequest) {
    const url = buildApiUrl('/api/v1/news-calendar/news/:id', { id });
    return apiClient.updateWithFile<PutNewsCalendarNewsResponse>(url, data);
  }

  static deleteNews(id: string) {
    const url = buildApiUrl('/api/v1/news-calendar/news/:id', { id });
    return apiClient.delete<void>(url, undefined);
  }
}
